import type { LeadStatsView } from '@lib/enums/lead-stats-view.enum'
import type { TenantFeature } from '@lib/enums/tenant-feature.enum'

/** How the Pipeline names its two views: it follows couples, not leads. */
export const PIPELINE_VIEW_LABELS: Readonly<Record<LeadStatsView, string>> = {
  cohort: 'Couples who inquired',
  activity: 'Everything that happened',
}

/** What a company has switched on that brings inquiries in: a venue can only connect what its company has. */
export interface CompanyConnections {
  gohighlevel: boolean
  honeybook: boolean
}

/** Which of the connections that bring inquiries in the company has switched on. */
export function companyConnections(features: readonly TenantFeature[]): CompanyConnections {
  return { gohighlevel: features.includes('gohighlevel'), honeybook: features.includes('honeybook') }
}

/** "GoHighLevel or HoneyBook", "HoneyBook": what a venue here could connect, or null at a company with neither. */
export function connectableText(has: CompanyConnections): string | null {
  const names = [has.gohighlevel ? 'GoHighLevel' : null, has.honeybook ? 'HoneyBook' : null].filter((n) => n !== null)
  return names.length === 0 ? null : names.join(' or ')
}
